import * as Yup from 'yup';

export const EMAIL_REGEX = /^([a-z0-9_\.\-])+\@(([a-z0-9\-])+\.)+([a-z0-9]{2,4})+$/;
export const PHONE_REGEX = /^[(00)|(+)]{1}[0-9\\s.\\/-]{12,13}$/;

export const getEmailValidator = () =>
  Yup.string().strict(true).matches(EMAIL_REGEX, 'Enter valid email. Only lowercase letter');
